import { render, staticRenderFns } from "./DailyAssignmentsModal.vue?vue&type=template&id=5d2f35e8&"
import script from "./DailyAssignmentsModal.vue?vue&type=script&lang=js&"
export * from "./DailyAssignmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports